import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import airfreightratesServices from '../../Services/airfreightratesServices'
import Loader from '../../Components/Loader'
import { PhoneCode } from '../../Components';

export const EditSalesAgent = () => {

    const [loader, setLoader] = useState(false)

    const history = useHistory()
    const formik = useFormik({
        initialValues: {
            corporates_name: '',
            confirm_account_number: '',
            account_number: '',
            corporates_type: '',
            registration_number: '',
            normal_amount: '',
            full_name: '',
            mobile_number: '',
            corporates_email: '',
            corporates_business_ddress: '',
            taxation_details: '',
            rate_cards: '',
            account_holder_name: '',
            branch_address: '',
            branch_name: '',
            routing_number: ''
        },
        validationSchema: Yup.object({
            corporates_email: Yup.string().required('Required').email('Please enter valide email'),
            mobile_number: Yup.number()
                .typeError('Must be a number')
                .required("Required")
                .min(10, "Too short"),
            // corporates_name: Yup.string().required('Required'),
            // confirm_account_number: Yup.string().required('Required'),
            // account_number: Yup.string().required('Required'),
            // corporates_type: Yup.string().required('Required'),
            // registration_number: Yup.string().required('Required'),
            // normal_amount: Yup.string().required('Required'),
            // full_name: Yup.string().required('Required'),
            // mobile_number: Yup.string().required('Required'),
            // corporates_email: Yup.string().required('Required'),
            // corporates_business_ddress: Yup.string().required('Required'),
            // taxation_details: Yup.string().required('Required'),
            // rate_cards: Yup.string().required('Required'),
            // account_holder_name: Yup.string().required('Required'),
            // branch_address: Yup.string().required('Required'),
            // branch_name: Yup.string().required('Required'),
            // routing_number: Yup.string().required('Required'),

        }),
        onSubmit: values => {
            setLoader(true)
            let postData = {
                ...values,
                corporates_email:values.corporates_email.toLowerCase()
            }
            airfreightratesServices.addAirfreightrates(postData).then(res => {
                if (res.status) {
                    setLoader(false)
                    history.push('/air-freight-rate-list')
                } else {
                    setLoader(false)
                    toast.error(res.message)
                }
            })
        },
    });

    // const onSelect = (e) => {
        // let newArry1 = []
        // let newArry2 = []
        // arry1.map(list => {
        //     newArry1.push({ ...list, isdisabled: list.value === e.value })
        // })
        // arry2.map(list => {
        //     newArry2.push({ ...list, isdisabled: list.value === e.value })
        // })

    // }

    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <form className="control-form">
                            <div className="row">
                                <div className="mb-3 col-6">
                                    <label className="form-label">Agent Name</label>
                                    <input
                                        required={false}
                                        type="text"
                                        className={'form-control' + (formik.touched.corporates_name ? !formik.errors.corporates_name ? ' is-valid' : ' is-invalid' : '')}
                                        {...formik.getFieldProps('corporates_name')}
                                        placeholder="Enter Agent Name"
                                    />
                                    {formik.touched.corporates_name && formik.errors.corporates_name ? (
                                        <div className="text-danger">{formik.errors.corporates_name}</div>
                                    ) : null}
                                </div>
                                <div className="mb-3 col-6">
                                    <label className="form-label">Email ID</label>
                                    <input
                                        type="email"
                                        className={'form-control' + (formik.touched.retailer_email ? !formik.errors.retailer_email ? ' is-valid' : ' is-invalid' : '')}
                                        {...formik.getFieldProps('retailer_email')}
                                        placeholder="Enter Email"
                                    />
                                    {formik.touched.retailer_email && formik.errors.retailer_email ? (
                                        <div className="text-danger">{formik.errors.retailer_email}</div>
                                    ) : null}
                                </div>
                            </div>
                            <div className="row">
                                <div className="mb-3 col-6">
                                    <div className="form-group border">
                                        <label className="form-label">Contact No.</label>
                                        <div
                                            className={(formik.touched.mobile_number ? !formik.errors.mobile_number ? ' contact-success' : ' contact-error' : '')}
                                        >
                                            <PhoneCode
                                                Addphone={(value) => formik.setValues({ ...formik.values, mobile_number: value })}
                                                phone={formik.values.mobile_number}
                                            />
                                        </div>
                                    </div>
                                    {formik.touched.mobile_number && formik.errors.mobile_number ? (
                                        <div className="text-danger">{formik.errors.mobile_number}</div>
                                    ) : null}
                                </div>
                                <div className="mb-3 col-6">
                                    <label className="form-label">Registered Address</label>
                                    <input
                                        type="text"
                                        className={'form-control' + (formik.touched.retailer_business_ddress ? !formik.errors.retailer_business_ddress ? ' is-valid' : ' is-invalid' : '')}
                                        {...formik.getFieldProps('retailer_business_ddress')}
                                        placeholder="Enter Business Address"
                                    />
                                    {formik.touched.retailer_business_ddress && formik.errors.retailer_business_ddress ? (
                                        <div className="text-danger">{formik.errors.retailer_business_ddress}</div>
                                    ) : null}
                                </div>
                            </div>
                            <div className="row">
                                <div className="mb-3 col-6">
                                    <label className="form-label">Taxation Details</label>
                                    <input
                                        type="text"
                                        className={'form-control' + (formik.touched.taxation_details ? !formik.errors.taxation_details ? ' is-valid' : ' is-invalid' : '')}
                                        {...formik.getFieldProps('taxation_details')}
                                        placeholder="Enter Taxation Details"
                                    />
                                    {formik.touched.taxation_details && formik.errors.taxation_details ? (
                                        <div className="text-danger">{formik.errors.taxation_details}</div>
                                    ) : null}
                                </div>
                                <div className="mb-3 col-6">
                                    <label className="form-label">Total Discount</label>
                                    <input
                                        className={'form-control' + (formik.touched.normal_amount ? !formik.errors.normal_amount ? ' is-valid' : ' is-invalid' : '')}
                                        {...formik.getFieldProps('normal_amount')}
                                        placeholder="Enter Total Discount"
                                    />
                                    {formik.touched.normal_amount && formik.errors.normal_amount ? (
                                        <div className="text-danger">{formik.errors.normal_amount}</div>
                                    ) : null}
                                </div>
                            </div>
                            <div className="mt-3 d-flex justify-content-between">
                                <button
                                    className="btn btn-danger w-sm waves-effect waves-light"
                                    type="button"
                                    onClick={() => history.goBack()}
                                >Back</button>
                                <button className="btn btn-primary w-sm waves-effect waves-light"
                                    type="button"
                                    onClick={() => formik.handleSubmit()}
                                >Submit</button>
                            </div>
                        </form>
                        <Loader isShow={loader} />
                    </div>
                </div>
            </div>
        </div>
    )
}
